import _ from "lodash";
import {ChartComponent} from "../components/insights/charts/BaseChart";
import {FieldChartType} from "../types/fieldChart";
import {VirtualSoilMoistureProbeChart} from "../components/insights/charts/VirtualSoilMoistureProbeChart";
import {ActualEvapotranspirationChart} from "../components/insights/charts/ActualEvapotranspirationChart";
import {VirtualTensiometerChart} from "../components/insights/charts/VirtualTensiometerChart";
import {EvapotranspirationAppliedWaterCumulativeChart} from "../components/insights/charts/EvapotranspirationAppliedWaterCumulativeChart";
import {DryMatterProductionCumulativeChart} from "../components/insights/charts/DryMatterProductionCumulativeChart";
import {PercentVegetationCoverChart} from "../components/insights/charts/PercentVegetationCoverChart";
import {NetCarbonSupplyInSoilChart} from "../components/insights/charts/NetCarbonSupplyInSoilChart";
import {PrecipitationChart} from "../components/insights/charts/PrecipitationChart";
import {AirTemperatureChart} from "../components/insights/charts/AirTemperatureChart";
import {CustomChart} from "../components/insights/charts/CustomChart";
import {AggregatedLayerType} from "../types/domain/aggregatedLayerType";
import {LeafNitrogenChart} from "../components/insights/charts/LeafNitrogenChart";

export interface ChartProps {
    id: FieldChartType;
    label: string;
    component: ChartComponent;
}

export const CHARTS: ChartProps[] = [
    {
        id: FieldChartType.CUSTOM_1,
        label: "Custom Chart 1",
        component: CustomChart,
    },
    {
        id: FieldChartType.CUSTOM_2,
        label: "Custom Chart 2",
        component: CustomChart,
    },
    {
        id: FieldChartType.CUSTOM_3,
        label: "Custom Chart 3",
        component: CustomChart,
    },
    {
        id: FieldChartType.VIRTUAL_SOIL_MOISTURE_PROBE,
        label: "Virtual Soil Moisture Probe",
        component: VirtualSoilMoistureProbeChart,
    },
    {
        id: FieldChartType.ACTUAL_EVAPOTRANSPORTATION,
        label: "Actual Evapotranspiration",
        component: ActualEvapotranspirationChart,
    },
    {
        id: FieldChartType.VIRTUAL_TENSIOMETER,
        label: "Virtual Tensiometer",
        component: VirtualTensiometerChart,
    },
    {
        id: FieldChartType.EVAPOTRANSPIRATION_APPLIED_WATER_CUMULATIVE,
        label: "Evapotranspiration Applied Water Cumulative",
        component: EvapotranspirationAppliedWaterCumulativeChart,
    },
    {
        id: FieldChartType.DRY_MATTER_PRODUCTION_CUMULATIVE,
        label: "Dry Matter Production Cumulative",
        component: DryMatterProductionCumulativeChart,
    },
    {
        id: FieldChartType.PERCENT_VEGETATION_COVER,
        label: "Percent Vegetation Cover",
        component: PercentVegetationCoverChart,
    },
    {
        id: FieldChartType.LEAF_NITROGEN,
        label: "Leaf Nitrogen",
        component: LeafNitrogenChart,
    },
    {
        id: FieldChartType.NET_CARBON_SUPPLY_IN_SOIL,
        label: "Net Carbon Supply in Soil",
        component: NetCarbonSupplyInSoilChart,
    },
    {
        id: FieldChartType.PRECIPITATION,
        label: "Precipitation",
        component: PrecipitationChart,
    },
    {
        id: FieldChartType.AIR_TEMPERATURE_AND_GDU,
        label: "Air Temperature and GDU",
        component: AirTemperatureChart,
    },
];

export const CHARTS_MAP = _.keyBy(CHARTS, "id");

export const ADMIN_CHART_PROP_NAMES = Object.values(AggregatedLayerType);
export const USER_CHART_PROP_NAMES = [
    "vegetation_cover",
    "uniformity_vegetation_cover_stdmean",
    "irrigation_yesno",
    "area_percentage_requiring_irrigation",
    "area_percentage_over_irrigation",
    "fullness",
    "adviced_applied_water",
    "time_until_next_irrigation",
    "soil_moisture_root_zone_today",
    "soil_water_potential_root_zone",
    "actual_evapotranspiration",
    "potential_evapotranspiration",
    "potential_transpiration",
    "penmann_monteith_reference_et0",
    "penmann_monteith_crop_coefficient_kc_mw",
    "actual_crop_production",
    "water_unlimited_crop_production",
    "transpiration_deficit",
    "uniformity_soil_moisture_stdmean",
    "water_productivity",
    "field_efficiency",
    "applied_water",
    "irrigation_amount_cumulative",
    "actual_evaporation",
    "actual_transpiration",
    "actual_transpiration_cumulative",
    "transpiration_ratio",
    "stomatal_conductance",
    "air_temperature_24",
    "air_temperature_min_24",
    "air_temperature_max_24",
    "relative_humidity_24",
    "vpd_24",
    "root_depth",
    "penmann_monteith_crop_coefficient_kc",
    "daily_solar_radiation",
    "daily_net_radiation",
    "precipitation",
    "runoff_r",
    "runoff_r_cumulative",
    "percolation",
    "percolation_cumulative",
    "theta_sat_sub",
    "theta_fc_sub",
    "theta_wp_sub",
    "water_storage_root_zone",
    "soil_moisture_holding_capacity",
    "critical_soil_moisture_root_zone",
    "soil_moisture_standard_deviation",
    "uniformity_crop_production_cumulative_stdmean",
    "soil_moisture_percentile5",
    "soil_moisture_percentile95",
    "vegetation_cover_percentile5",
    "vegetation_cover_percentile95",
    "crop_production_cumulative_percentile5",
    "crop_production_cumulative_percentile95",
    "crop_production_percentile5",
    "crop_production_percentile95",
    "crop_production_cumulative",
    "actual_evapotranspiration_applied_water",
    "actual_evapotranspiration_applied_water_cumulative",
    "percolation_applied_water",
    "actual_evapotranspiration_cumulative",
    "precipitation_cumulative",
    "water_productivity_season",
    "soil_water_potential_percentile5",
    "soil_water_potential_percentile95",
    "soil_water_potential_critical",
    "soil_water_potential_fc",
    "leaf_water_potential",
    "n_leaf_percentage",
    "n_leaf_production",
    "moisture_content_cane",
    "sugar_content_cane",
    "attainable_biomass_production",
    "attainable_biomass_production_cumulative",
    "water_unlimited_crop_production_cumulative",
    "production_gap",
    "production_gap_cumulative",
    "organic_matter",
    "soil_temperature",
    "leaf_temperature_inst",
    "carbon_supply_in_soil",
    "carbon_decomposition_in_soil",
    "net_carbon_supply_in_soil",
    "net_carbon_supply_in_soil_cumulative",
    "delta_organic_matter_content",
    "thermal_degrees_days_cumulative",
    "thermal_update",
    "visible_update",
    "s2_day",
    "p_fcdp0",
    "p_fcdp1",
    "p_fcdp2",
    "p_fcdp3",
    "p_fcdp4",
    "p_fcdp5",
    "p_fcdp6",
    "p_fcdp7",
    "et_fcdp0",
    "et_fcdp1",
    "et_fcdp2",
    "et_fcdp3",
    "et_fcdp4",
    "et_fcdp5",
    "et_fcdp6",
    "et_fcdp7",
    "aw_fcdp0",
    "aw_fcdp1",
    "aw_fcdp2",
    "aw_fcdp3",
    "aw_fcdp4",
    "aw_fcdp5",
    "aw_fcdp6",
    "aw_fcdp7",
    "critical_soil_moisture_root_zone_fcdp0",
    "critical_soil_moisture_root_zone_fcdp1",
    "critical_soil_moisture_root_zone_fcdp2",
    "critical_soil_moisture_root_zone_fcdp3",
    "critical_soil_moisture_root_zone_fcdp4",
    "critical_soil_moisture_root_zone_fcdp5",
    "critical_soil_moisture_root_zone_fcdp6",
    "critical_soil_moisture_root_zone_fcdp7",
    "soil_moisture_root_zone_no_irri_fcdp0",
    "soil_moisture_root_zone_no_irri_fcdp1",
    "soil_moisture_root_zone_no_irri_fcdp2",
    "soil_moisture_root_zone_no_irri_fcdp3",
    "soil_moisture_root_zone_no_irri_fcdp4",
    "soil_moisture_root_zone_no_irri_fcdp5",
    "soil_moisture_root_zone_no_irri_fcdp6",
    "soil_moisture_root_zone_no_irri_fcdp7",
    "soil_moisture_root_zone_irri_fcdp0",
    "soil_moisture_root_zone_irri_fcdp1",
    "soil_moisture_root_zone_irri_fcdp2",
    "soil_moisture_root_zone_irri_fcdp3",
    "soil_moisture_root_zone_irri_fcdp4",
    "soil_moisture_root_zone_irri_fcdp5",
    "soil_moisture_root_zone_irri_fcdp6",
    "soil_moisture_root_zone_irri_fcdp7",
    "actual_evapotranspiration_precipitation",
    "wind_speed_24_T1",
    "wind_speed_24",
];
